
/* eslint-disable camelcase */
import common_es from './es/common.json';
import common_en from './en/common.json';

export default {
  en: {
    common: common_en,
  },
  es: {
    common: common_es,
  },
};
